export default __webpack_public_path__ + "static/media/layout-img.963bd28d.png";